import { Sector } from '@/domain/impact/impact.entity';
import { getScoreLetterFromScore } from '@/domain/impact-calculate/utils/get-score-letter-from-score';
import { CalculateFestivalEss } from '@/domain/impact-calculate-festival/entities/calculate-festival-ess.entity';
import { EssTopic } from '@/domain/impact-ess/entities/question.entity';
import { translate } from '@/ui/i18n';
import { TopicScoreDetailsData } from '@/ui/pages/app/components/topic-score-card/type';
import {
  formatUnit,
  getEssTopicName,
} from '@/ui/utils/ess-env-names-and-format';

export function prepareScoreSectorDetailsDataEss(
  calculateEss: CalculateFestivalEss,
  sector: Sector,
): TopicScoreDetailsData {
  return {
    value:
      sector !== '' ? calculateEss.sectors[sector].score : calculateEss.score,
    scoreLetter:
      sector &&
      calculateEss.sectors[sector].score &&
      calculateEss.sectors[sector].maxScore
        ? getScoreLetterFromScore(
            calculateEss.sectors[sector].score /
              calculateEss.sectors[sector].maxScore,
          )
        : '-',
    refValue: NaN,
    maxValue: (sector && calculateEss.sectors[sector].maxScore) || NaN,
    completion: NaN,
    sections: [
      {
        name: translate('Projects.details'),
        items: [
          {
            id: 'PARITY_EQUALITY',
            name: getEssTopicName(EssTopic.PARITY_EQUALITY),
            value: calculateEss.topics.PARITY_EQUALITY.score,
            unit: formatUnit(calculateEss.topics.PARITY_EQUALITY.maxScore),
          },
          {
            id: 'ACCESSIBILITY_SOCIAL_DIALOGUE',
            name: getEssTopicName(EssTopic.ACCESSIBILITY_SOCIAL_DIALOGUE),
            value: calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.score,
            unit: formatUnit(
              calculateEss.topics.ACCESSIBILITY_SOCIAL_DIALOGUE.maxScore,
            ),
          },
          {
            id: 'LOCAL_IMPACT_RSE_ENGAGEMENT',
            name: getEssTopicName(EssTopic.LOCAL_IMPACT_RSE_ENGAGEMENT),
            value: calculateEss.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.score,
            unit: formatUnit(
              calculateEss.topics.LOCAL_IMPACT_RSE_ENGAGEMENT.maxScore,
            ),
          },
        ],
      },
    ],
  };
}
